export default __webpack_public_path__ + "static/media/Atualizar 3.23a8f3c7.svg";